import { render } from "@/share/components/controls/paginationTable/PaginationTable.html?vue&type=template&id=626c2668&scoped=true&external"
import script from "@/share/components/controls/paginationTable/PaginationTable.js?vue&type=script&lang=js&external"
export * from "@/share/components/controls/paginationTable/PaginationTable.js?vue&type=script&lang=js&external"

import "@/share/components/controls/paginationTable/PaginationTable.scss?vue&type=style&index=0&id=626c2668&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626c2668"]])

export default __exports__